import filters from '../actions/filters';
import filterSelectors from '../selectors/filters';

const defaultState = {
    modifiers: {
        query: {},
        paging: {}
    },
    filterBar: null,
    shownFilters: null
};

export default function(state = defaultState, action) {
    const resetPageIndex = () => ({
        page: 1,
        size: state.modifiers.paging.size
    });

    const setPageSize = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            paging: {
                page: 1,
                size: action.payload
            }
        }
    });

    const changeSortValue = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            sort: {
                sorting: action.payload.sort,
                order: action.payload.sortOrder
            },
            paging: resetPageIndex()
        }
    });

    const changeSortOrder = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            sort: {
                sorting: state.modifiers.sort.sorting,
                order:
                    state.modifiers.sort.order === 'Descending'
                        ? 'Ascending'
                        : 'Descending'
            },
            paging: resetPageIndex()
        }
    });

    const changeTypeValue = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            itemType: action.payload,
            paging: resetPageIndex()
        }
    });

    const setDateFrom = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            dateRange: {
                from: action.payload,
                to: state.modifiers.dateRange.to,
                field: state.modifiers.dateRange.field
            },
            paging: resetPageIndex()
        }
    });

    const setSingleFilter = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            sellerFilters: {
                ...state.modifiers.sellerFilters,
                [action.payload.filter]: action.payload.value
            }
        }
    });
    const setDateTo = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            dateRange: {
                to: action.payload,
                from: state.modifiers.dateRange.from,
                field: state.modifiers.dateRange.field
            },
            paging: resetPageIndex()
        }
    });

    const setFiltersByState = () => {
        let showSelectFiltersDropDown = false;
        if (action.payload === 'Valj') {
            showSelectFiltersDropDown = !state.filterBar
                .showSelectFiltersDropDown;
        }
        const updatedState = filterSelectors.setSellerFilterBarModifiers(
            state,
            action.payload
        );
        return {
            ...updatedState,
            defaults: {
                ...state.defaults
            },
            modifiers: {
                ...updatedState.modifiers,
                selectedFilterBar: action.payload,
                paging: resetPageIndex()
            },
            filterBar: {
                ...state.filterBar,
                values: state.filterBar.values,
                showSelectFiltersDropDown: showSelectFiltersDropDown
            }
        };
    };

    const changePage = () => {
        const updatedPaging = {
            page: action.page,
            size: state.modifiers.paging.size
        };
        return {
            ...state,
            modifiers: {
                ...state.modifiers,
                paging: updatedPaging
            }
        };
    };

    const resetDateRangeTo = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            dateRange: {
                ...state.modifiers.dateRange,
                to: state.defaults.modifiers.dateRange.to
            }
        }
    });

    const resetDateRangeFrom = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            dateRange: {
                ...state.modifiers.dateRange,
                from: state.defaults.modifiers.dateRange.from
            }
        }
    });

    const resetFilters = () => ({
        ...state,
        modifiers: { ...state.defaults.modifiers },
        filterBar: { ...state.filterBar, ...state.defaults.filterBar }
    });

    const changeSearchQuery = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            query: {
                searchQuery: action.payload,
                properties: state.modifiers.query.properties,
                scope: state.modifiers.query.scope
            },
            sort: {
                sorting: 'BestMatch',
                order: 'Ascending'
            },
            paging: resetPageIndex()
        }
    });

    const changeReservationPrice = () => ({
        ...state,
        modifiers: {
            ...state.modifiers,
            reservePriceReached: action.payload,
            paging: resetPageIndex()
        }
    });

    const setFiltersForPage = () => {
        if (!action.payload.newFilters.modifiers) {
            return state;
        }
        return {
            ...state,
            ...action.payload.newFilters,
            defaults: {
                ...action.payload.defaultFilters
            }
        };
    };

    const locationChange = () => ({
        ...state,
        modifiers: action.payload.filters
    });

    const showHideFilterToolbar = () => ({
        ...state
    });

    const reducers = {
        [filters.actionTypes.SET_PAGE_SIZE]: setPageSize,
        [filters.actionTypes.CHANGE_SORT_VALUE]: changeSortValue,
        [filters.actionTypes.CHANGE_SORT_ORDER]: changeSortOrder,
        [filters.actionTypes.CHANGE_TYPE_VALUE]: changeTypeValue,
        [filters.actionTypes.CHANGE_SORTING_TO_BEST_MATCH]: changeSortOrder,
        [filters.actionTypes.SET_DATE_FROM]: setDateFrom,
        [filters.actionTypes.SET_SINGLE_FILTER]: setSingleFilter,
        [filters.actionTypes.SET_DATE_TO]: setDateTo,
        [filters.actionTypes.SET_FILTERS_BY_STATE]: setFiltersByState,
        [filters.actionTypes.CHANGE_PAGE]: changePage,
        [filters.actionTypes.RESET_DATE_RANGE_TO]: resetDateRangeTo,
        [filters.actionTypes.RESET_DATE_RANGE_FROM]: resetDateRangeFrom,
        [filters.actionTypes.RESET_FILTERS]: resetFilters,
        [filters.actionTypes.CHANGE_SEARCH_QUERY]: changeSearchQuery,
        [filters.actionTypes.CHANGE_RESERVATION_PRICE]: changeReservationPrice,
        [filters.actionTypes.SET_FILTERS_FOR_PAGE]: setFiltersForPage,
        [filters.actionTypes.LOCATION_CHANGE]: locationChange,
        [filters.actionTypes.SHOW_HIDE_FILTERS]: showHideFilterToolbar
    };

    if (!reducers[action.type]) {
        return state;
    } else {
        return reducers[action.type]();
    }
}

export const selectFiltersState = state => state.views.myTradera.filters;
